import { Card, CardContent, CardHeader, Collapse, Container, IconButton, makeStyles } from "@material-ui/core";
import KeyboardArrowUp from '@material-ui/icons/KeyboardArrowUp';
import KeyboardArrowDown from '@material-ui/icons/KeyboardArrowDown';
import React, { useState } from "react";

const useStyles = makeStyles(() => ({
    header: {
        cursor: 'pointer',
        '& svg': {
            width: '24px !important',
            height: '24px !important',
        }
    },
    contentContainer: {
        height: "max-content",
        backgroundColor: "#F3F6FC"
    }
}));

export default function CollapseCounsil({ title, ...props }) {
    const [open, setOpen] = useState(false);
    const classes = useStyles();

    return (
        <>
            <Card sx={{
                minWidth: 300,
                border: "1px solid rgba(211,211,211,0.6)",
                height: open ? "auto" : 56,
            }}>
                <CardHeader
                    title={title}
                    onClick={() => setOpen(!open)}
                    className={classes.header}
                    action={
                        <IconButton
                            aria-label="expand"
                            size="small"
                        >
                            {open ? <KeyboardArrowUp />
                                : <KeyboardArrowDown />}
                        </IconButton>
                    }
                ></CardHeader>
                <div className={classes.contentContainer}>
                    <Collapse in={open} timeout="auto" className="">
                        <CardContent>
                            <Container>
                                {props.children}
                            </Container>
                        </CardContent>
                    </Collapse>
                </div>
            </Card>
        </>
    );
}
